import React from 'react';
import { Button, TextField, OutlinedInput } from '@mui/material';
import {
	GridColumns,
	GridActionsCellItem,
	GridApiRef,
	GridRenderCellParams,
	GridRenderEditCellParams,
} from '@mui/x-data-grid-pro';
import { RiArrowUpLine, RiArrowDownLine } from 'react-icons/ri';
import { stringEnum } from 'common/utils/objects';
import { TFunction } from 'i18next';
import { VariantProperty } from 'common/modules/inventory/types';

export const STATIC_COLUMNS = stringEnum(['VARIANT']);
const { VARIANT } = STATIC_COLUMNS;

export const getFixedColumnsStart = (t: TFunction) => [
	{
		field: VARIANT,
		headerName: VARIANT,
		renderHeader: () => <div>{t('product.variant')}</div>,
		flex: 1.5,
		sortable: false,
		disableColumnMenu: true,
		editable: false,
	},
];

export const getDynamicColumns = (properties: VariantProperty[], isDisabled?: boolean) =>
	properties?.map(({ id, name }) => ({
		field: id,
		headerName: name.def,
		renderHeader: () => <div>{name.def}</div>,
		flex: 1,
		minWidth: 100,
		sortable: false,
		editable: true,
		type: 'text',
		getActions: () => null,
		renderCell: (params: GridRenderCellParams) => (
			<OutlinedInput
				id="component-outlined"
				value={params.value ?? ''}
				size="small"
				disabled={isDisabled}
				fullWidth
			/>
		),
		renderEditCell: (params: GridRenderEditCellParams) => {
			const { id, value, api, field } = params;

			return (
				<TextField
					id="outlined-name"
					autoFocus
					value={value}
					size="small"
					fullWidth
					disabled={isDisabled}
					onChange={(event) => {
						api.setEditCellValue({ id, field, value: event.target.value }, event);
					}}
				/>
			);
		},
	}));

interface ActionsColumnProps {
	apiRef: GridApiRef;
	actions: {
		onHeaderClick: () => void;
		moveRow: (id: string, direction: 1 | -1) => void;
	};
	t: TFunction;
	isDisabled?: boolean;
}

export const getActionsColumn = (props: ActionsColumnProps): GridColumns => {
	const { actions, t, isDisabled } = props;
	const { onHeaderClick, moveRow } = actions;

	return [
		{
			field: 'actions',
			headerName: t('common:actions.actions', 'Actions'),
			type: 'actions',
			headerAlign: 'right',
			align: 'right',
			minWidth: 180,
			renderHeader: () => (
				<Button variant="text" color="primary" onClick={onHeaderClick} disabled={isDisabled}>
					{t('product.addOption', 'Add option')}
				</Button>
			),
			getActions: ({ id }) => {
				return [
					<GridActionsCellItem
						icon={<RiArrowUpLine />}
						label={t('common:actions.save')}
						onClick={() => moveRow(id.toString(), -1)}
						color="primary"
						disabled={isDisabled}
					/>,
					<GridActionsCellItem
						icon={<RiArrowDownLine />}
						label={t('common:actions.cancel')}
						onClick={() => moveRow(id.toString(), 1)}
						color="inherit"
						disabled={isDisabled}
					/>,
				];
			},
		},
	];
};
